<template>
    <div v-if="loaded">
        <div class="categories shrinker">
            <div v-for="track in breakoutTracks" class="categories__category">

                <div v-if="!track.hasSessions" class="category-card category-card--no-sessions">
                    <p>{{ track.category }}
                    <div class="category-card__no-sessions-label">More info coming soon!</div>
                </div>

                <div v-if="track.hasSessions" class="category-card" v-on:click="setTrack(track)">
                    <p>{{ track.category }}</p>
                </div>

            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import axios from 'axios'
    import transitionToFromAuto from 'transition-to-from-auto'
    import scrollToElement from 'scroll-to-element'

    export default {

        components: {

        },

        data: function() {
            return {
                track: null,
                loaded: false,
                filteredTracks: null
            }
        },

        props: [
            'breakoutTracks',
            'sessions',
            'speakers',
            'timeslots'
        ],

        methods: {

            setTrack: function(track) {
                this.track = track;
                this.$parent.currentModalComponent = 'ScheduleModal';
                this.$parent.modalArguments = {
                    scheduleSwitcherView: 'track',
                    timeslots: this.timeslots,
                    sessions: this.sessions,
                    speakers: this.speakers,
                    breakoutTracks: this.breakoutTracks,
                    track: this.track
                };
                this.$parent.showModal = true;
                document.body.classList.add("modal-open");
            },

            filterTracks: function() {
                var validTracks = [];
                for(var i = 0; i < this.sessions.length; i++) {
                    if(this.sessions[i].eventSessionCategories) {
                        for(var j = 0; j < this.sessions[i].eventSessionCategories.length; j++) {
                            if(validTracks.indexOf(this.sessions[i].eventSessionCategories[j]) == -1) {
                                validTracks.push(this.sessions[i].eventSessionCategories[j]);
                            }
                        }
                    }
                }

                // Identify Tracks with content
                var newTracks = [];
                for(var i = 0; i < this.breakoutTracks.length; i++) {
                    for(var j = 0; j < validTracks.length; j++) {
                        if(this.breakoutTracks[i].catSequence == validTracks[j]) {
                            this.breakoutTracks[i].hasSessions = true;
                        }
                    }
                }

                this.loaded = true;
            }
        },

        created: function() {

        },

        watch: {
            sessions: function(sessions) {
                if(this.breakoutTracks) {
                    this.filterTracks();
                }
            },

            breakoutTracks: function(breakoutTracks) {
                if(this.sessions) {
                    this.filterTracks();
                }
            }
        }


    }
</script>


// WEBPACK FOOTER //
// BreakoutTracks.vue?716d3c2f